import { createAction, props } from '@ngrx/store';
import { Encounter } from '@mona/models';
import { AuditEvent } from '../../../../../shared/src/lib/types/r4b.type';

/**
 * load audit log
 */
export const loadAuditLogs = createAction(
    'AUDIT_LOG:LOAD_AUDIT_LOGS',
    props<{ encounter: Encounter; backendPage: number }>(),
);
/**
 * load audit log Success
 */
export const loadAuditLogsSuccess = createAction(
    'AUDIT_LOG:LOAD_AUDIT_LOGS_SUCCEEDED',
    props<{
        backendPage: number;
        items: AuditEvent[];
        totalCount: number;
        paginationId: string;
        backendPageSize: number;
    }>(),
);
/**
 * load audit log Failure
 */
export const loadAuditLogsFailure = createAction('AUDIT_LOG:LOAD_AUDIT_LOGS_FAILED', props<{ error: any }>());
/**
 * set audit log page
 */
export const setPage = createAction('AUDIT_LOG:SET_PAGE', props<{ currentPage: number; pageSize: number }>());
/**
 * clear audit log
 */
export const clearAuditLog = createAction('AUDIT_LOG:CLEAR_AUDIT_LOGS');
